.dda-range-slider-container {
  width: 100%;
  margin: 20px 0;
  position: relative;
}

.dda-range-slider {
  position: relative;
  width: 100%;
  height: 6px;
  background: var(--dda-neutral-variant-92);
  border-radius: 5px;
}

.dda-range-slider-input {
  position: absolute;
  width: 100%;
  height: 6px;
  background: transparent;
  -webkit-appearance: none;
  appearance: none;
  pointer-events: none;
  border: 0;
  margin: 0;
  padding: 0;
}

.dda-range-slider-input::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--dda-neutral-100);
  border: solid 2px var(--dda-neutral-90);
  cursor: pointer;
  pointer-events: all;
}

.dda-range-slider-input::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border: 0;
  border-radius: 50%;
  background: var(--dda-color-primary-40);
  cursor: pointer;
  pointer-events: all;
  /* -moz-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out; */
}

.dda-range-slider-track {
  position: absolute;
  height: 100%;
  background: var(--dda-color-primary-40);
  border-radius: 5px;
}

.light-mode .dda-range-slider-track{
  background: var(--dda-primary-40);
}

.dda-range-slider-track span {
  background: var(--dda-neutral-100);
  width: 55px;
  height: 35px;
  font-size: 16px;
  color: var(--dda-on-surface-variant-30);
  font-weight: var(--dda-fw-500);
  text-align: center;
  position: absolute;
  top: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.light-mode .dda-range-slider-track span{
  color: var(--dda-neutral-variant-30);
}

.dda-tooltip-top .dda-range-slider-track span{
  top: auto;
  bottom: 24px;
}
.dda-tooltip-bottom .dda-range-slider-track span{
  top: 24px;
}
.dda-range-slider-track .min-label {
  left: -17px;
}

.dda-range-slider-track .max-label {
  right: -33px;
}

.dda-tooltip-top .dda-range-slider-track span,
.dda-tooltip-bottom .dda-range-slider-track span{
  border: solid 1px var(--dda-neutral-90);
  border-radius: 4px;
  -webkit-box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.04);
  -moz-box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.04);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.04);
}
.dda-tooltip-top .dda-range-slider-track span::before, 
.dda-tooltip-top .dda-range-slider-track span::after,
.dda-tooltip-bottom .dda-range-slider-track span::before, 
.dda-tooltip-bottom .dda-range-slider-track span::after {
  content: "";
  position: absolute;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  left: 50%;
  margin-inline-start: -10px;
}
.dda-tooltip-top .dda-range-slider-track span::before {
  top: 100%;
  border-top: 8px solid var(--dda-neutral-90);
  margin-top: 0px;
}
.dda-tooltip-top .dda-range-slider-track span::after {
  top: 100%;
  border-top: 8px solid var(--dda-neutral-100);
  margin-top: -2px;
  z-index: 1;
}
.dda-tooltip-bottom .dda-range-slider-track span::before {
  bottom: 100%;
  border-bottom: 8px solid var(--dda-neutral-90);
  margin-bottom: 0px;
}
.dda-tooltip-bottom .dda-range-slider-track span::after {
  bottom: 100%;
  border-bottom: 8px solid var(--dda-neutral-100);
  margin-bottom: -2px;
  z-index: 1;
}

@media (prefers-reduced-motion: no-preference) {
  .dda-range-slider-input::-moz-range-thumb {
    -moz-transition: all 0.15s ease-in-out;
    transition: all 0.15s ease-in-out;
  }
}